/** @jsx jsx */
import * as React from "react";
import { jsx } from "@emotion/core";
import * as styles from './style';


interface IRestDayProps {

}

export const RestDay: React.FC<IRestDayProps> = (props: IRestDayProps) => {

    return (
        <div css={styles.restDayWrapper}>
            <img src="/images/rest-day.png" alt="Rest Day" css={styles.restImage} />
            <div css={styles.restDayTitle}>It’s a rest day!</div>
        </div>
    )
}